import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/core/services/common.service';
import { NotificationComponent } from '../notification/notification.component';
import { CookieService } from 'ngx-cookie-service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  @ViewChild('dropdownButton') dropdownButton!: ElementRef;
  @ViewChild('dropdownButton1') dropdownButton1!: ElementRef;
  isMouseInsideMenu: boolean = false;
  showSearch = false;
  searchText: string = '';
  language: string = '';
  menuToCreate: any[] = [];
  menuToView: any[] = [];
  menuArray: any;
  userDetail: any;
  firstName = '';
  orgName!: string | null;
  orgGrpId: any = [];
  subMenu = false;
  menuSubModules: any[] = [];
  modules: any[] = [];
  mainModule: any;
  activeMenu: boolean = false;
  activeModule: any[] = [];
  subModule: any;
  breadcrumbHistory: any[] = [];
  imageURL!: Observable<string>;
  loginUrl:any;
  uadOrgin!:string;
  currentLang: string = 'en'; // Default language
  constructor(
    private router: Router,
    private cookieService: CookieService,
    private restService: RestService, 
    private dialog: MatDialog, 
    private loader: LoaderService,
    private commonService: CommonService, 
    private errorHandler: ErrorHandlerService,
    private translate: TranslateService) { 
      // translate.setDefaultLang('fr')
    }

  ngOnInit(): void {
    // this.getMenuData();
   this.getMenu();
  }

  isMobileScreen(): boolean {
    return window.innerWidth < 768; // Change the threshold as per your requirement
  }

  getMenu() {
    this.restService
      .postUADLogin(null, 'api/UAD/FetchAllModulesforLogedInRole')
      .subscribe(
        (data: any) => {
          if (data.rcode == 200) {
            this.modules = data.rObj.modulesforRole;
            if (this.modules?.length > 0) {
              //this.menuToView = this.modules;
              // this.menuToView = this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === null && module.url === null);
              // Assuming 'menuToView' is your array of main modules
              const menuToView = this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === null && module.url === null);

              // Function to get sub-modules for a given main module
              const getSubModules = (mainModule: any) =>
                this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === mainModule.sWAModuleID && module.url === null);

              // Function to get direct functionality modules for a given main module
              const getDirectFunctionalityModules = (mainModule: any) =>
                this.modules.filter((module: any) => module.isFunctionality && module.parentModuleID === mainModule.sWAModuleID && module.url !== null);

              // Function to get functionality items for a given submodule
              const getFunctionalityItems = (subModule: any) =>
                this.modules.filter((module: any) => module.isFunctionality && module.parentModuleID === subModule.sWAModuleID && module.url !== null);

              // Map main modules and add sub-modules, direct functionality modules, and functionality items
              const hierarchicalModules = menuToView.map(mainModule => ({
                ...mainModule,
                subModules: getSubModules(mainModule).map(subModule => ({
                  ...subModule,
                  functionalityItems: getFunctionalityItems(subModule)
                })),
                activeModules: getDirectFunctionalityModules(mainModule)
              }));

              // Use the 'hierarchicalModules' array based on your specific requirements
              this.menuToView = hierarchicalModules;
            }
            this.userDetail = data.rObj.userDetails;
            this.uadOrgin=data.rObj.uadOrigin;
          }
        },
        (error: any) => {
          this.errorHandler.handleStatusError(error);
        }
      );
  }

  getMenuData() {
    this.loader.show();
    this.restService.postDataDs(null, 'api/digital/core/Module/FetchAllModulesforLogedinRole').subscribe(
      {
        next: (data) => {
          try {
          if (data.rcode === 200) {
            this.modules = data.rObj.modulesforRole;
            if (this.modules?.length > 0) {
              //this.menuToView = this.modules;
              // this.menuToView = this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === null && module.url === null);
              // Assuming 'menuToView' is your array of main modules
              const menuToView = this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === null && module.url === null);

              // Function to get sub-modules for a given main module
              const getSubModules = (mainModule: any) =>
                this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === mainModule.sWAModuleID && module.url === null);

              // Function to get direct functionality modules for a given main module
              const getDirectFunctionalityModules = (mainModule: any) =>
                this.modules.filter((module: any) => module.isFunctionality && module.parentModuleID === mainModule.sWAModuleID && module.url !== null);

              // Function to get functionality items for a given submodule
              const getFunctionalityItems = (subModule: any) =>
                this.modules.filter((module: any) => module.isFunctionality && module.parentModuleID === subModule.sWAModuleID && module.url !== null);

              // Map main modules and add sub-modules, direct functionality modules, and functionality items
              const hierarchicalModules = menuToView.map(mainModule => ({
                ...mainModule,
                subModules: getSubModules(mainModule).map(subModule => ({
                  ...subModule,
                  functionalityItems: getFunctionalityItems(subModule)
                })),
                activeModules: getDirectFunctionalityModules(mainModule)
              }));

              // Use the 'hierarchicalModules' array based on your specific requirements
              this.menuToView = hierarchicalModules;
            }
            this.userDetail = data.rObj.userDetails;
          } else {
            this.errorHandler.handleRcodeError(data);
          }
          } catch (error) {
            this.errorHandler.internalError();
          } finally{
            this.loader.hide();
          }
        },
        error: (error) => {
          this.errorHandler.handleStatusError(error);
        }
      }
    );
  }

  navigateToSubMenu(type: string, Id: number, url: string, item: any, dropdown: string, event: Event) {
    if (item.subModules && item.activeModules?.length == 0 && (url == null || url == '') && !item.isFunctionality) {
      event.preventDefault();
      event.stopPropagation();
      this.subMenu = true;
      this.activeMenu = false;
      this.mainModule = item;
      this.menuSubModules = item.subModules;
    } else if (item.activeModules && item.subModules && (url == null || url == '') && !item.isFunctionality) {
      event.preventDefault();
      event.stopPropagation();
      this.subMenu = true;
      this.activeMenu = false;
      this.subModule = '';
      this.mainModule = item;
      this.menuSubModules = item.activeModules;
    } else if (item.functionalityItems && (url == null || url == '') && !item.isFunctionality) {
      event.preventDefault();
      event.stopPropagation();
      this.subMenu = false;
      this.activeMenu = true;
      this.subModule = item;
      this.activeModule = item.functionalityItems;
    } else {
      this.closeDropdown(dropdown);
      let mainModuleName = this.mainModule ? this.mainModule.moduleName + ' / ' : '';
      let subModuleName = this.subModule ? this.subModule.moduleName + ' / ' : '';
      let activeModule = this.modules.find((module: any) => module.sWAModuleID === Id);
      let relativeUrl
        const currentOrigin = window.location.origin; // Get the current site's origin
        const urlOrigin = new URL(url).origin; // Extract the origin from the full URL
       
        if (currentOrigin == urlOrigin) {
          // Same origin, navigate using the relative path
          relativeUrl = new URL(url).pathname;
          this.router.navigate([relativeUrl]);
        } else {
          // Different origin, reload the full URL
          window.location.href = url;
        }
      this.breadcrumbHistory = JSON.parse(sessionStorage.getItem('BCArray') || '[]');
      // if (sessionStorage.getItem('breadCrumbs')) {
      //   sessionStorage.removeItem('breadCrumbs');
      // }
      sessionStorage.setItem('breadCrumbs', mainModuleName + subModuleName + activeModule.moduleName);

      let routeURL = {
        url: url,
        breadCrumb: mainModuleName + subModuleName + activeModule.moduleName
      }
      this.breadcrumbHistory.push(routeURL);
      sessionStorage.setItem('BCArray', JSON.stringify(this.breadcrumbHistory));
    }
    // if (url == '' || url == null) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   let menuData = this.modules.find((module: any) => module.sWAModuleID && module.parentModuleID == null);
    //   if (menuData && menuData.sWAModuleID == Id) {
    //     this.subMenu = true;
    //     this.activeMenu = false;
    //     this.mainModule = '';
    //     this.mainModule = this.modules.find((module: any) => module.sWAModuleID === Id);
    //     this.menuSubModules = this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID !== null && module.parentModuleID === Id);

    //   } else {
    //     this.subMenu = false;
    //     this.activeMenu = true;
    //     this.subModule = '';
    //     this.subModule = this.modules.find((module: any) => module.sWAModuleID === Id);
    //     this.activeModule = this.modules.filter((module: any) => module.isFunctionality && module.parentModuleID !== null && module.parentModuleID === Id);
    //   }
    //   // if (this.subMenu) {
    //   //   this.subMenu = false;
    //   //   this.activeMenu = true;
    //   //   this.subModule = this.modules.find((module: any) => module.sWAModuleID === Id);
    //   //   this.activeModule = this.modules.filter((module: any) => module.isFunctionality && module.parentModuleID !== null  && module.parentModuleID === Id );
    //   // } else {
    //   //   this.subMenu = true;
    //   //   this.activeMenu = false;
    //   //   this.mainModule = this.modules.find((module: any) => module.sWAModuleID === Id && !module.isFunctionality);
    //   //   this.menuSubModules = this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID !== null && module.parentModuleID === Id);
    //   // }
    // } else if (url != '' && url != null) {
    //   this.closeDropdown(dropdown);
    //   // Check if mainModule and subModule are defined, otherwise use an empty string
    //   let mainModuleName = this.mainModule ? this.mainModule.moduleName + ' / ' : '';
    //   let subModuleName = this.subModule ? this.subModule.moduleName + ' / ' : '';
    //   let activeModule = this.modules.find((module: any) => module.sWAModuleID === Id);
    //   this.router.navigate([url]);
    //   if (sessionStorage.getItem('breadCrumbs')) {
    //     sessionStorage.removeItem('breadCrumbs');
    //   }
    //   sessionStorage.setItem('breadCrumbs', mainModuleName + subModuleName + activeModule.moduleName);

    //   let routeURL = {
    //     url: url,
    //     breadCrumb: mainModuleName + subModuleName + activeModule.moduleName
    //   }
    //   this.breadcrumbHistory.push(routeURL);
    //   sessionStorage.setItem('BCArray', JSON.stringify(this.breadcrumbHistory));
    // }

  }

  menuBack(event: Event, value: string) {
    event.preventDefault();
    event.stopPropagation();
    if (value == 'subMenu') {
      this.subMenu = !this.subMenu;
    } else {
      this.subMenu = true;
      this.activeMenu = false;
    }

  }

  Dashboard() {
    this.router.navigate(['/home']);
  }

  sendData() {
    window.location.href = this.uadOrgin +'/'+ 'view/my-profile'
  }
  
  logout() {
    this.closeDropdown('dropdownButton');
    const dialogRef = this.dialog.open(NotificationComponent, {
      disableClose: true,
      panelClass: 'dialog-class',
      data: {
        block: 'yesOrNo',
        message: this.translate.instant('Logout_Msg')
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.logOutWithRedirect();
      }
    });
  }

  logOutWithRedirect() {
    this.loader.show();
    let params = {};
    this.restService
      .postUADLogin(params, 'api/digital/core/Account/Logout')
      .subscribe(
        (data) => {
          if (data.rcode == 200) {
            this.loader.hide();
            this.loginUrl = data.rObj.redirectURL;
            localStorage.clear();
            window.location.href = this.loginUrl;
          } else {
            this.commonService.handleRcodeError(data);
          }
        },
        (error) => {
          this.commonService.handleStatusError(error);
        }
      );
  }

  closeDropdown(drop: string): void {
    if (drop == 'dropdownButton1') {
      if (this.dropdownButton1) {
        this.dropdownButton1.nativeElement.click();
      }
    } else if (drop == 'dropdownButton') {
      if (this.dropdownButton) {
        this.dropdownButton.nativeElement.click();
      }
    }
  }

  preventClose(event: Event) {
    event.stopPropagation();
  }

  orgChart() {
    this.closeDropdown('dropdownButton');
    this.router.navigate(['/view/org-structure']);
  }








  navigateToSubMenus(type: string, Id: number, url: string, item: any, dropdown: string, event: Event) {
    if (item.subModules && item.activeModules.length == 0 && (url == null || url == '') && !item.isFunctionality) {
      event.preventDefault();
      event.stopPropagation();
      this.subMenu = true;
      this.activeMenu = false;
      this.mainModule = item;
      this.menuSubModules = item.subModules;

      // this.mapSubModuleUrls(item)
      // url = item.url
      // this.closeDropdown(dropdown);
      // let mainModuleName = this.mainModule ? this.mainModule.moduleName + ' / ' : '';
      // let subModuleName = this.subModule ? this.subModule.moduleName + ' / ' : '';
      // let activeModule = this.modules.find((module: any) => module.sWAModuleID === Id);
      // this.router.navigate([url]);
      // this.breadcrumbHistory = JSON.parse(sessionStorage.getItem('BCArray') || '[]');
      // sessionStorage.setItem('breadCrumbs', mainModuleName + subModuleName + activeModule.moduleName);

      // let routeURL = {
      //   url: url,
      //   breadCrumb: mainModuleName + subModuleName + activeModule.moduleName
      // }
      // this.breadcrumbHistory.push(routeURL);
      // sessionStorage.setItem('BCArray', JSON.stringify(this.breadcrumbHistory));
    } else if ((item.functionalityItems && (url == null || url == '') && !item.isFunctionality) || (item.activeModules && item.subModules && (url == null || url == '') && !item.isFunctionality)) {
      this.mapModuleUrls(item)
      url = item.url
      this.closeDropdown(dropdown);
      let mainModuleName = this.mainModule ? this.mainModule.moduleName + ' / ' : '';
      let subModuleName = this.subModule ? this.subModule.moduleName + ' / ' : '';
      let activeModule = this.modules.find((module: any) => module.sWAModuleID === Id);
      this.router.navigate([url]);
      let relativeUrl
        const currentOrigin = window.location.origin; // Get the current site's origin
        const urlOrigin = new URL(url).origin; // Extract the origin from the full URL
       
        if (currentOrigin == urlOrigin) {
          // Same origin, navigate using the relative path
          relativeUrl = new URL(url).pathname;
          this.router.navigate([relativeUrl]);
        } else {
          // Different origin, reload the full URL
          window.location.href = url;
        }
   
      this.breadcrumbHistory = JSON.parse(sessionStorage.getItem('BCArray') || '[]');
      sessionStorage.setItem('breadCrumbs', mainModuleName + subModuleName + activeModule.moduleName);

      let routeURL = {
        url: url,
        breadCrumb: mainModuleName + subModuleName + activeModule.moduleName
      }
      this.breadcrumbHistory.push(routeURL);
      sessionStorage.setItem('BCArray', JSON.stringify(this.breadcrumbHistory));
    }
    else {
      this.closeDropdown(dropdown);
      let mainModuleName = this.mainModule ? this.mainModule.moduleName + ' / ' : '';
      let subModuleName = this.subModule ? this.subModule.moduleName + ' / ' : '';
      let activeModule = this.modules.find((module: any) => module.sWAModuleID === Id);
      this.router.navigate([url]);
      sessionStorage.setItem('breadCrumbs', mainModuleName + subModuleName + activeModule.moduleName);

      this.breadcrumbHistory = JSON.parse(sessionStorage.getItem('BCArray') || '[]');
      let routeURL = {
        url: url,
        breadCrumb: mainModuleName + subModuleName + activeModule.moduleName
      }
      this.breadcrumbHistory.push(routeURL);
      sessionStorage.setItem('BCArray', JSON.stringify(this.breadcrumbHistory));
    }
  }


  mapModuleUrls(modules: any) {
    if (modules.sWAModuleID) {
      modules.url = `routing-module/${modules.sWAModuleID}`;
    }
    if (modules.subModules && modules.subModules.length > 0) {
      this.mapModuleUrls(modules.subModules);
    }
  }
  mapSubModuleUrls(modules: any) {
    if (modules.sWAModuleID) {
      modules.url = `routing-sub-module/${modules.sWAModuleID}`;
    }
    if (modules.subModules && modules.subModules.length > 0) {
      this.mapModuleUrls(modules.subModules);
    }
  }
changeLanguage(lang: string) {
  this.translate.use(lang);
  this.currentLang = lang;
}
}

